/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Carrier_Notices_Active_HelpInputs */

const en_carrier_notices_active_help = /** @type {(inputs: Carrier_Notices_Active_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Active notices appear in public checkout until they expire or are turned off.`)
};

const es_carrier_notices_active_help = /** @type {(inputs: Carrier_Notices_Active_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Los avisos activos aparecen en el checkout publico hasta que vencen o se desactivan.`)
};

/**
* | output |
* | --- |
* | "Active notices appear in public checkout until they expire or are turned off." |
*
* @param {Carrier_Notices_Active_HelpInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const carrier_notices_active_help = /** @type {((inputs?: Carrier_Notices_Active_HelpInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Carrier_Notices_Active_HelpInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_carrier_notices_active_help(inputs)
	return es_carrier_notices_active_help(inputs)
});